import script from "./OrderTagModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderTagModal.vue?vue&type=script&setup=true&lang=js"

import "./OrderTagModal.vue?vue&type=style&index=0&id=36d26c3c&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36d26c3c"]])

export default __exports__